import { hot } from 'react-hot-loader/root';
import React from 'react';
import { Provider } from 'react-redux';
import GamesPage from '../pages/GamesPage';
import createScoresStore from '../stores/scores-store';

const GamesRoot = props => (
  <Provider store={createScoresStore()}>
    <GamesPage {...props} />
  </Provider>
);

export default hot(GamesRoot);
